import { get, isArray, isObject, keys } from '@direct-frontend/stdlib';

import { getFieldPathById } from '../../store/utils/getFieldPathByFieldId';

import { BaseField, BaseFields } from '../types';

import { getActualUnionFieldConstituent } from './getActualUnionFieldConstituent';
import { stringifyFieldIdPath } from './stringifyFieldIdPath';
import { FormSliceState } from '../../store/types';

type Options = {
    field: BaseField;
    fieldsState: FormSliceState['forms'][string]['fieldsState'];
    formValue: unknown;
    fieldId: string;
    callback: (field: BaseField, fieldId: string) => void;
};

export function walkField({ field, fieldsState, formValue, fieldId, callback }: Options) {
    function walk(field: BaseField, fieldId: string) {
        walkField({ field, fieldId, fieldsState, formValue, callback });
    }

    const fieldState = fieldsState[fieldId];

    if (!fieldState) return;

    callback(field, fieldId);

    if (field.type === 'object') {
        for (const fieldName of keys(field.fields)) {
            const innerField = field.fields[fieldName];
            if (!innerField) continue;

            walk(innerField, stringifyFieldIdPath([fieldId, fieldName]));
        }
    }

    if (field.type === 'union') {
        const fieldValue = get(
            formValue,
            getFieldPathById(() => fieldsState, fieldId)
        );

        if (!isObject(fieldValue)) return;

        walk(getActualUnionFieldConstituent(field, fieldValue), fieldId);
    }

    if (field.type === 'array') {
        const fieldValue = get(
            formValue,
            getFieldPathById(() => fieldsState, fieldId)
        );

        if (!isArray(fieldValue) || !('order' in fieldState)) return;

        for (let index = 0; index < fieldValue.length; index = index + 1) {
            const arrayItemId = fieldState.order[index];
            if (!arrayItemId) continue;

            walk(field.field, arrayItemId);
        }
    }
}

export function walkFields({ fields, ...options }: Omit<Options, 'field' | 'fieldId'> & { fields: BaseFields }) {
    for (const name of keys(fields)) {
        const field = fields[name];
        if (!field) continue;

        walkField({ field, fieldId: name, ...options });
    }
}
